// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"icon-item_wrapper_dvevD","info":"icon-item_info_3bruP","title":"icon-item_title_2Uo5u","content":"icon-item_content_2WFp0"};